export default __webpack_public_path__ + "static/media/ecearina4.4a008bfc.jpg";